/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import { Box, ColorPicker as ColorPickerBase } from '@wix/design-system';
import React, { useContext, useEffect, useState } from 'react';

import { RicosContext } from './../../../../ricos-context';

import { FloatingLayout } from '../../../modal-layout/floating-layout/floating-layout';
import classes from './floating-custom-color-picker-scss';

export type FloatingCustomColorPickerProps = {
  title: string;
  color: string | undefined;
  onCancel: () => void;
  onConfirm: (color: string) => void;
  allowEmpty?: boolean;
};

const getColorHex = (color: $TSFixMe) => (typeof color === 'string' ? color : color.hex());

export const FloatingCustomColorPicker: React.FC<FloatingCustomColorPickerProps> = ({
  title,
  color,
  onCancel,
  onConfirm,
  allowEmpty,
}) => {
  const { t, isMobile } = useContext(RicosContext);

  const [colorValue, setColorValue] = useState(color ?? '');

  useEffect(() => {
    setColorValue(color ?? colorValue);
  }, [color]);

  return (
    <FloatingLayout
      onCloseButtonClick={onCancel}
      sidePanelProps={{
        height: 'fit-content',
        width: isMobile ? '100%' : 'fit-content',
      }}
      header={
        isMobile
          ? {
              title,
            }
          : undefined
      }
      content={{
        children: (
          <Box align="center">
            <div
              className={isMobile ? classes.colorPicker : undefined}
              tabIndex={0}
              aria-label={title}
            >
              <ColorPickerBase
                value={colorValue}
                showConverter={false}
                onChange={newColor => {
                  setColorValue(getColorHex(newColor));
                }}
                onConfirm={newColor => {
                  onConfirm(getColorHex(newColor));
                }}
                onCancel={onCancel}
                allowEmpty={allowEmpty}
                emptyPlaceholder={t('CustomColorPicker_Empty_Placeholder')}
              />
            </div>
          </Box>
        ),
      }}
    />
  );
};
